import React from 'react'

import DownloadList from './DownloadList'
import DownloadListItem from './DownloadListItem'
import Error from '../../common/primitives/Error'

const SingleFolderDownloadList = ({ files }) => {
  return (
    <>
      {!files || files.length === 0 ? (
        <Error message="No files found. Please try again or contact Awa for help." />
      ) : (
        <DownloadList>
          {files.map((file, idx) => (
            <DownloadListItem key={idx} file={file} />
          ))}
        </DownloadList>
      )}
    </>
  )
}

export default SingleFolderDownloadList
